module.exports = __webpack_public_path__ + "assets/abe2fc47da86092757b357b30e6cb37b.png";